'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var paperDepthStyles = {
    none: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    box-shadow: none;\n  "], ["\n    box-shadow: none;\n  "]))),
    1: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    box-shadow: ", ";\n  "], ["\n    box-shadow: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.shadows.depth_1;
    }),
    2: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    box-shadow: ", ";\n  "], ["\n    box-shadow: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.shadows.depth_2;
    }),
    3: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    box-shadow: ", ";\n  "], ["\n    box-shadow: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.shadows.depth_3;
    }),
    4: styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    box-shadow: ", ";\n  "], ["\n    box-shadow: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.shadows.depth_4;
    }),
    5: styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    box-shadow: ", ";\n    &:hover {\n      box-shadow: ", ";\n    }\n  "], ["\n    box-shadow: ", ";\n    &:hover {\n      box-shadow: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.shadows.depth_5;
    }, function (_a) {
        var theme = _a.theme;
        return theme.shadows.depth_5_hover;
    }),
};
var borderRadiusStyles = {
    none: styled.css(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n    border-radius: 0;\n  "], ["\n    border-radius: 0;\n  "]))),
    sm: styled.css(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n    border-radius: 4px;\n  "], ["\n    border-radius: 4px;\n  "]))),
    md: styled.css(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n    border-radius: 8px;\n  "], ["\n    border-radius: 8px;\n  "]))),
};
var Paper = styled__default.div(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n\n  box-sizing: border-box;\n  ", ";\n  ", ";\n"], ["\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n\n  box-sizing: border-box;\n  ", ";\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var _b = _a.depth, depth = _b === void 0 ? 1 : _b;
    return paperDepthStyles[depth];
}, function (_a) {
    var _b = _a.borderRadius, borderRadius = _b === void 0 ? 'none' : _b;
    return borderRadiusStyles[borderRadius];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

exports.Paper = Paper;
exports.borderRadiusStyles = borderRadiusStyles;
exports.paperDepthStyles = paperDepthStyles;
